export const examsQueryKeys = {
  all: ['exams'],
  details: () => [...examsQueryKeys.all, 'detail'],
  detail: (id) => [...examsQueryKeys.details(), id],
  recentForPatient: (id) => [...examsQueryKeys.all, 'recentForPatient', id],
  pagination: (page, filters: Record<string, unknown> = {}) => {
    const filterKey = JSON.stringify(filters);
    return [...examsQueryKeys.all, 'pagination', page.toString(), filterKey];
  },
  infinite: () => [...examsQueryKeys.all, 'infinite'],
};
